import { AlertTriangle, Trash2, UserX } from 'lucide-react';
import { Avatar } from '@components/avatar';
import { SvgConsumer } from '@components/icons/svgConsumer';
import { formatTenantTime } from '@utils/i18n';
import { cn } from '@utils/cn';
import { ConflictLink } from '../conflictLink';
import { ResourceRowProps } from './types';

const actionClass =
  'flex h-10 w-10 shrink-0 items-center justify-center rounded-md text-neutral-400 disabled:opacity-50';

export const ResourceRow = ({
  name,
  role,
  conflicts,
  deactivated,
  disabled,
  swapLabel,
  removeLabel,
  deactivatedLabel,
  onSwap,
  onRemove,
  conflictDays,
  onShowConflicts,
}: ResourceRowProps) => (
  <div className="flex flex-col gap-1.5 pl-2.5">
    <div className="flex min-h-11 items-center gap-2.5">
      <Avatar
        name={deactivated ? '' : name}
        hideTooltip
        className={cn('h-8 w-8 text-sm', deactivated && 'bg-neutral-200')}>
        {deactivated && <UserX className="h-4 w-4 text-white" />}
      </Avatar>
      <span className="flex min-w-0 flex-1 flex-col leading-tight">
        <span
          className={cn(
            'flex items-center gap-1.5 truncate text-[15px] font-semibold text-neutral-700',
            deactivated && 'text-neutral-300 line-through',
          )}>
          <span className="truncate">{name}</span>
          {!deactivated &&
            (onShowConflicts && !!conflictDays ? (
              <ConflictLink compact count={conflictDays} onClick={onShowConflicts} />
            ) : (
              !!conflicts.length && (
                <AlertTriangle className="h-3.5 w-3.5 shrink-0 text-warning-500" />
              )
            ))}
        </span>
        <span className="truncate text-xs text-neutral-400">
          {deactivated ? deactivatedLabel : role}
        </span>
      </span>
      <button
        type="button"
        aria-label={swapLabel}
        disabled={disabled}
        onClick={onSwap}
        className={actionClass}>
        <SvgConsumer id="replacePerson" className="text-lg" />
      </button>
      <button
        type="button"
        aria-label={removeLabel}
        disabled={disabled}
        onClick={onRemove}
        className={actionClass}>
        <Trash2 className="h-[18px] w-[18px]" />
      </button>
    </div>
    {!deactivated &&
      !onShowConflicts &&
      conflicts.map((el) => (
        <div
          key={el.scheduleId}
          className="ml-10 flex flex-col rounded-md border border-warning-200 bg-warning-50 px-2.5 py-1.5 text-xs leading-tight text-neutral-800">
          <span className="font-bold">
            {[formatTenantTime(el.startsAt), formatTenantTime(el.endsAt)].join(' - ')}
          </span>
          <span className="font-medium">
            {[el.name, el.projectIdentifier].filter(Boolean).join(' · ')}
          </span>
        </div>
      ))}
  </div>
);
